@if (processedValue()) {
  <span class="line-clamp-3 break-after-all">
    {{ processedValue() }}
  </span>
} @else {
  <span class="text-text-tertiary">—</span>
}
